import type { FC } from "react";
import { AdvisorPickerRow } from "web_myplann/Advisor/Components/AdvisorPickerRow";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

type Props = {
	advisors: AgentAssignedListItemResponseDTO[];
	selectedId?: string;
	onSelect: (id: string) => void;
};

export const AdvisorPickerList: FC<Props> = ({
	advisors,
	selectedId,
	onSelect,
}) => (
	<>
		{advisors.map((advisor) => (
			<AdvisorPickerRow
				key={advisor.uid}
				name={advisor.name}
				photo={advisor.avatar ?? undefined}
				role={advisor.role ?? undefined}
				unreadCount={advisor.unreadCount}
				isMain={advisor.isMain}
				isSelected={advisor.uid === selectedId}
				onClick={() => onSelect(advisor.uid)}
			/>
		))}
	</>
);
